import axios from '@/lib/axios';

const signOut = () => {
  return axios.delete("customer/sign_out");
}

export default signOut;